module.exports = __webpack_public_path__ + "img/hero-08.c155e2d7.jpg";